import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useClientContext } from '@bingads-webui-campaign-react/smart-page-context';
import { ItemCarousel, } from '@bingads-webui-campaign-react/smart-component-card';
import { withErrorView } from '@bingads-webui-campaign-react/smart-page-error-boundary';
import { SmartReviewCard } from './components/smart-review-card';

const getStyles = components => ({
  title: {
    ...components.sectionTitle,
  },
  reviewContainer: {
    ...components.section,
  },
  reviewContainerMargin: {
    marginLeft: '7%',
    marginRight: '7%',
  },
});

export const UnStyledSmartReviewView = ({
  classes,
  i18n,
  reviews,
  id,
}) => {
  const { isMobile, responsiveMode } = useClientContext();

  return (
    <div
      id={id}
      className={classNames(
        classes.reviewContainer,
        !isMobile && classes.reviewContainerMargin
      )}
    >
      <h2 className={classNames(classes.title, 'component-title')}>
        {i18n.getString(_TL_('Testimonials'))}
      </h2>
      <div>
        <ItemCarousel
          items={reviews}
          responsiveSize={responsiveMode}
          i18n={i18n}
          CardComponent={SmartReviewCard}
        />
      </div>
    </div>
  );
};

UnStyledSmartReviewView.propTypes = {
  classes: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  reviews: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
  id: PropTypes.string.isRequired,
};

export const SmartReviewView = withErrorView(withDefaultStyles(
  UnStyledSmartReviewView,
  getStyles
), 'componentMode');
